import ModeShippingWizard from "./modeShippingWizard.js";

export default class StoreShippingWizard extends ModeShippingWizard {

  constructor($container, options) {
    super($container, options);
  }

  update(modeDetails, options) {
    if (this.$list === undefined) {
      // this.$list = $('<ul/>', { class: 'store-modes' }).appendTo(this.$container);
      this.$list = $(`<table>
            <tbody>
            <tr>
                <td><ul class="store-modes"/></td>
            </tr>
            </tbody>
        </table>`).appendTo(this.$container).find('ul')
    }
    this.$list.empty();

    // the shipping must be choosen in dumb list
    for (let offer of modeDetails.offers) {
      let $choice = $('<li/>')
        .appendTo(this.$list)
        .click(event => {
          this.selectCarrier(offer, $choice)
        })
        .html(`
              <span class="checkbox"/>
              <span class="name"><img src="${this.settings.ressources.images[offer.type] != undefined ? require('../../images/interface/default/livraison/' + this.settings.ressources.images[offer.type]) : ''}" alt="${offer.provider}"/></span>
              
              <div class="text">
                  ${offer.provider.length ? `<h4>${offer.provider}</h4>` : ''}
                  <p class="description">${offer.description}</p>
              </div>
              
              <span class="cost">${offer.cost.total > 0 ? StringUtils.toLocaleString(offer.cost.total, { style: 'currency', currency: 'EUR' }) : ' Gratuit'}</span> 
              <div class="address">
                <i class="fa fa-building" aria-hidden="true"></i>
                <h4>
                  <span class="lastname">BÉBÉ AU NATUREL</span>
                </h4>
                <p class="address">
                  <span class="street">ZA Moustoir Nord</span><br/>
                  <span class="cp">56950</span>
                  <span class="ville">CRAC'H</span>
                </p>
              </div>
          `) //Gratuit ligne 38 g�re le gratuit du BB au naturel page panier 2
    }
  }

  resetSelection() {
    this.$list.find(' > li.selected').removeClass('selected');
  }

  selectCarrier(offer, $choice) {
    this.resetSelection();
    $choice.addClass('selected');
    super.on('select', offer, $choice);
  }
}
